import { useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { useLocation } from 'react-router-dom';

export const usePageTitle = () => {
    const { selectedApp } = useUser();
    const location = useLocation();

    useEffect(() => {
      const appNames = {
        grammar: 'Grammarly',
        spelling: 'Spelling Pro',
        vocabulary: 'Vocabulary Builder',
        writing: 'Writing Assistant'
      };
  
      const pathTitles = {
        '/': 'Dashboard',
        '/initial-test': 'Initial Assessment',
        '/mode/correction': 'Grammar Correction',
        '/mode/construction': 'Sentence Construction',
        '/mode/story': 'Story Writing',
        '/mode/adaptive': 'Adaptive Learning',
        '/mode/exam': 'Practice Exam',
        '/mode/word_completion': 'Word Completion',
        '/mode/audio_spelling': 'Audio Spelling',
        '/mode/anagram_challenge': 'Anagram Challenge',
        '/mode/definition_spelling': 'Definition Spelling',
        '/mode/spelling_bee': 'Spelling Bee',
        '/mode/story_spelling': 'Story Spelling',
        '/writing-test': 'Writing Test',
        '/writing-results': 'Test Results',
        '/results': 'Test Results',
        '/complete-profile': 'Complete Your Profile',
        '/vocabulary/learn_practice/flashcards': 'Vocabulary Flashcards',
        '/vocabulary/learn_practice/sentence_usage': 'Sentence Usage Practice',
        '/vocabulary/learn_practice/word_association': 'Word Association',
        '/vocabulary/guess-meaning': 'Guess the Meaning'
      };
  
      const currentPath = location.pathname;
      let pageTitle = 'Learning Apps';
  
      // Check if it's a specific path
      for (const [path, title] of Object.entries(pathTitles)) {
        console.log(path, currentPath, 'check');
        if (path.includes(currentPath)) {
          pageTitle = title;
          break;
        }
        if (currentPath.includes('/writely/mode/')) {
            pageTitle = currentPath.split('/')[3].split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            break;
        }
        if (currentPath.includes('/vocabulary/')) {
            pageTitle = 'Vocabulary';
            break;
        }
        if (currentPath.includes('/writing-test')) {
            pageTitle = 'Writing Test';
            break;
        }
        if (currentPath.includes('/writing-results')) {
            pageTitle = 'Test Results';
            break;
        }
      }
  
      // If on dashboard, include the selected app name
      if (currentPath === '/' && selectedApp) {
        pageTitle = `Dashboard - ${appNames[selectedApp]}`;
      }
  
      document.title = `${pageTitle} by Scholarly`;
    }, [selectedApp, location.pathname]);
  };